import React, { useEffect, useState } from "react";
import {
  getWrapupCodes,
  getQueueWrapupCodes,
} from "../utilities/genesysCloudUtils";
import "../App.css";
import { Pagination } from "./Pagination";
import { DataTable, DxButton } from "genesys-react-components";
import { Loading } from "./Loading";

const PAGE_SIZE = 500;
const RATE_LIMIT_DELAY = 200;

export function WrapupCodesTable({ queues, searchWrapupCodesValue }) {
  const [wrapupCodes, setWrapupCodes] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchWrapupCodes();
    fetchQueueWrapupCodes();
  }, [pageNumber, queues, searchWrapupCodesValue]);

  const fetchWrapupCodes = async () => {
    let opts = {
      pageSize: PAGE_SIZE,
      pageNumber,
      sortBy: "name",
      sortOrder: "ascending",
    };
    if (searchWrapupCodesValue) {
      opts.name = `*${searchWrapupCodesValue}*`;
    }
    const data = await getWrapupCodes(opts);
    setWrapupCodes(data.entities);
    setPageCount(data.pageCount);
  };

  console.log("Wrapup Codes:", wrapupCodes);

  const fetchQueueWrapupCodes = async () => {
    const updatedQueues = [...queues];
    const promises = updatedQueues.map((queue) =>
      delay(RATE_LIMIT_DELAY).then(async () => {
        const data = await getQueueWrapupCodes(queue.id, { pageSize: PAGE_SIZE, pageNumber: 1 });
        queue.wrapUpCodes = data.entities;
      })
    );
    await Promise.all(promises);
    setLoading(false);
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const onPageChange = (pageNumber) => {
    setPageNumber(pageNumber);
    setLoading(true);
  };

  const generateQueueRows = (queues) =>
    queues.map((queue, index) => ({
      cells: [
        {
          content: queue.name,
          align: "center",
          className: `cell-${index}`,
        },
      ],
    }));

  const generateWrapupRows = (wrapupCodes, queues) =>
    wrapupCodes.map((code) => ({
      cells: queues.map((queue, index) => {
        const isActive = queue.wrapUpCodes?.some((queueCode) => queueCode.id === code.id);
        return {
          renderedContent: isActive ? (
            <DxButton type="secondary" className="code-active">
              ✔
            </DxButton>
          ) : (
            " "
          ),
          content: isActive ? "true" : "false",
          align: "center",
          className: `cell-${index}`,
        };
      }),
    }));

  const tableProps = {
    className: "table",
    headerRow: {
      cells: [
        { content: "Wrap Up Code", align: "center" },
        {
          renderedContent: (
            <DataTable
              sortable={false}
              filterable={false}
              rows={generateQueueRows(queues)}
              className="queue-table"
            />
          ),
          content: "",
          align: "left",
          className: "queue-table-cell",
        },
      ],
    },
    indentation: 0,
    rows: wrapupCodes.map((code, index) => ({
      cells: [
        { content: code.name, align: "left" },
        {
          renderedContent: (
            <DataTable
              rows={[generateWrapupRows([code], queues)[0]]}
              className="queue-wrap-code-table"
            />
          ),
          content: "true",
          align: "center",
        },
      ],
    })),
  };

  return (
    <>
      {loading ? (
        <Loading loadingText="Fetching data..." />
      ) : (
        <>
          <Pagination
            pageCount={pageCount}
            pageNumber={pageNumber}
            onPageChange={onPageChange}
          />
          <DataTable
            sortable={false}
            filterable={false}
            headerRow={tableProps.headerRow}
            rows={tableProps.rows}
            className="main-table table-pin-rows"
          />
        </>
      )}
    </>
  );
}